import { GuestDataWrapper } from "./styles";
import { Grid } from "@mui/material";
import { CustomDivider, HeaderSection } from "../reservationInfo/styles";
import { useTranslation } from "react-i18next";
import Input from "@Common/input";
import { FORM_REGEX_VALIDATORS } from "@utils";
import UserOctagonIcon from "@assets/svg/UserOctagonIcon.svg?react";
import { Toggle } from "@components";
import {
  DirectPaymentContainer,
  DirectPaymentSubtitle,
  DirectPaymentTitle,
  DirectPaymentTextContainer,
  PhoneInputWrapper,
  PhoneHelperText,
} from "./styles";
import useBreakPoinst from "@hooks/useBreakPoinst";
import { useFormContext } from "react-hook-form";
import { useGetUserDetail } from "@services";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { reservationDetails } from "@store/index";

export default function GuestData() {
  const { t } = useTranslation();
  const { isPhone } = useBreakPoinst();
  const { watch, setValue } = useFormContext();
  const reservationDetailsValue = useRecoilValue(reservationDetails);
  const [isUserPaymentActive, setIsUserPaymentActive] = useState(
    reservationDetailsValue?.isDirectPaymentAccepted
  );
  useEffect(() => {
    setIsUserPaymentActive(reservationDetailsValue?.isDirectPaymentAccepted);
  }, []);
  const { data: userData } = useGetUserDetail();
  const isPaymentEnabled = (userData?.result as any)?.isUserPaymentActive;

  return (
    <GuestDataWrapper>
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <HeaderSection>
              <UserOctagonIcon />
              <p>{t("MANUALRESERVATION.GUESTDATA")}</p>
            </HeaderSection>
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              name="guestName"
              label={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
              placeholder={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
              registerOptions={{
                required: {
                  value: true,
                  message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSFIRSTNAME"),
                },
                pattern: {
                  value: FORM_REGEX_VALIDATORS.textOnly,
                  message: t("MANUALRESERVATION.ACCEPTTEXTONLY"),
                },
              }}
            />
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12} md={6}>
            <PhoneInputWrapper>
              <Input
                name="guestPhoneNumber"
                label={t("MANUALRESERVATION.GUESTMOBILENUMBER")}
                placeholder="50 xxx xxxx"
                registerOptions={{
                  required: {
                    value: true,
                    message: t(
                      "MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBER"
                    ),
                  },
                  pattern: {
                    value: FORM_REGEX_VALIDATORS.phone,
                    message: t(
                      "MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBERCORRECTLY"
                    ),
                  },
                }}
              />
              <PhoneHelperText>
                مثال: 50 123 4567 (رقم سعودي)
              </PhoneHelperText>
            </PhoneInputWrapper>
          </Grid>
          <CustomDivider />
          <Grid item xs={12}>
            <DirectPaymentContainer $isPhone={isPhone}>
              <DirectPaymentTextContainer $isPhone={isPhone}>
                <DirectPaymentTitle $isPhone={isPhone}>
                  {t("MANUALRESERVATION.DIRECT_PAYMENT_RECEIPT")}
                </DirectPaymentTitle>
                <DirectPaymentSubtitle $isPhone={isPhone}>
                  {t("MANUALRESERVATION.PAYMENT_LINK_DESCRIPTION")}
                </DirectPaymentSubtitle>
              </DirectPaymentTextContainer>
              {isPaymentEnabled ? (
                <Toggle
                  checked={isUserPaymentActive}
                  onChange={(event, checked) => {
                    setIsUserPaymentActive(checked);
                    setValue("isUserPaymentActive", checked);
                  }}
                />
              ) : null}
            </DirectPaymentContainer>
          </Grid>
        </Grid>
      </div>
    </GuestDataWrapper>
  );
}
